import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { JRPCResponseError } from '@lentau/api/shared/jrpc/types';
import { UsersService } from 'angular-api-gateway/v1/api/users.service';
import { defaultApiGatewayParams } from '@lentau/core/api/gateway';
import { SuccessResponse } from 'angular-api-gateway/v1/model/successResponse';
import { SelectUserProfileRequest } from 'angular-api-gateway/v1/model/selectUserProfileRequest';

@Injectable({ providedIn: 'root' })
export class B2bOrganizationsApiService {
  private usersService: UsersService = inject(UsersService);

  /**
   * Меняет состояние выбранного профиля на бэке
   */
  public selectProfile(params: SelectUserProfileRequest): Observable<SuccessResponse> {
    return this.usersService
      .selectUserProfile({
        ...defaultApiGatewayParams,
        selectUserProfileRequest: params,
      })
      .pipe(catchError(this.handleSelectProfileError));
  }

  private handleSelectProfileError(error: JRPCResponseError): Observable<never> {
    return throwError(() => ({
      Code: error.code,
      Message: error.message,
      Description: error.message,
    }));
  }
}
